import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import logo from '../../images/SuperAppNoGamesTextOnly.png';

const NavBar = () => {
    const [isOpen, setisOpen] = React.useState(false);
    
    function handleClick() {
        setisOpen(!isOpen);
    }

    return (
        <nav className="fixed top-0 w-full z-30 bg-[#111827] shadow-lg mb-16">
            <div className="flex flex-row justify-between items-center py-2 px-6">
                <div className="flex flex-row justify-center items-center text-center font-semibold">
                    <HashLink smooth to="/#hero">
                        <img 
                            src={logo} 
                            alt="SuperApp Games" 
                            className="w-16 h-16"
                        />
                    </HashLink>
                </div>

                <div className="hidden lg:flex items-center space-x-8">
                    <HashLink smooth to="/#about" className="text-gray-600 hover:text-blue-900">
                        About
                    </HashLink>
                    <HashLink smooth to="/#services" className="text-gray-600 hover:text-blue-900">
                        Services  
                    </HashLink>
                    <Link to="/contact" className="text-gray-600 hover:text-blue-900">
                        Contact Us
                    </Link>
                    <Link to="/get-demo" className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-800">
                        Demo our products
                    </Link>
                </div>

                {/* Mobile menu button */}
                <div className="lg:hidden">
                    <button onClick={handleClick} className="text-blue-900">
                        <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            {isOpen && (
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                            )}
                            {!isOpen && (
                            <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                            )}
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile menu */}
            {isOpen && (
                <div className="lg:hidden">
                    <div className={`fixed transition-transform duration-300 ease-in-out transit flex justify-center left-0 w-full h-auto rounded-md p-24 bg-white lg:hidden shadow-xl top-14 ${  isOpen ? "block" : "hidden" } `}>
                        <div className='flex flex-col space-y-6'>
                            <NavLinks />
                        </div>                                                
                    </div>
                </div>
            )}
        </nav>
    )
    
}


export default NavBar;
